export default __webpack_public_path__ + "static/media/SUSig_Stack_red.edcea98f.png";